<div class="web-view" fxHide.xs fxHide.sm fxHide.lt-md>
  <div *ngIf="showSideBar">
    <app-movie-page-side-bar class="web-sideBar"></app-movie-page-side-bar>
  </div>
  <div class="web-header" fxLayout="row" *ngIf="movie">

    <img id="web-background-img" src="{{ movie?.eventImage }}" alt="" />
    <img class="waterMarked" [src]="officialLogo" alt="">
    <a (click)="backClicked()">
      <img id="web-back-arrow" [src]="backArrow" alt="backArrow" />
    </a>
    <div class="web-hamburger" (click)="openSideBar()">☰</div>
    <div class="web-name">cinejoy</div>
    <div class="web-shopping-cart"><app-shopping-cart></app-shopping-cart></div>
  </div>

  <div fxLayout="row" *ngIf="movie">
    <div class="web-video-div">
      <iframe allowfullscreen="" class="trailer_iframe" frameborder="0" mozallowfullscreen="" [src]="trailerUrl"
        webkitallowfullscreen=""></iframe>
      <div style="display: flex;">
        <iframe *ngIf="movie?.video1" allowfullscreen="" class="short_trailer_iframe" frameborder="0"
          mozallowfullscreen="" [src]="splContent" webkitallowfullscreen=""></iframe>
        <iframe *ngIf="movie?.video2" style="margin-left: 5px" allowfullscreen="" class="short_trailer_iframe"
          frameborder="0" mozallowfullscreen="" [src]="splContent1" webkitallowfullscreen=""></iframe>
      </div>

    </div>

    <div class="description-div" *ngIf="movie">
      <h1>{{ movie?.name }}</h1>
      <hr width="20px" />
      <div fxLayoutAlign="row" fxLayoutGap="30px">
        <div>{{ movie?.rating }}/10</div>
        <div>{{ movie?.runtime }} mins</div>
      </div>

      <div class="paragraph-div">
        <p [innerHTML]="movie?.FullDescription"></p>

        <div>
          <p>{{ movie?.casts }}</p>
        </div>

        <div fxLayoutAlign="row" fxLayoutGap="30px">
          <div>{{ movie?.language }}</div>
          <div>{{ movie?.country }}</div>
        </div>
        <div class="button-div" fxLayout="row">
          <button>{{ movie?.tags[0] }}</button>
          <button>{{ movie?.tags[1] }}</button>
          <button>{{ movie?.tags[2] }}</button>
        </div>
        <div>
          <p>
            Official Selection of Cinejoy featuring Cinequest Artists March 21 - March 31, 2024
          </p>

          <div fxLayout="row wrap" fxLayoutGap="10px">
            <button type="button" class="movie_button" *ngIf="movie.showbuybutton"
              (click)="open(movie?.eventId, movie, 'Buy')">
              Buy Tks
            </button>
            <button type="button" class="movie_button" *ngIf="movie.showwatchbutton"
              [routerLink]="['/cinejoy/showcase/movie/stream/', movie.eventId,getmovieName(movie.name)]">
              Watch
            </button>
            <button *ngIf="movie.user > 0" type="button" class="movie_button" (click)="openDialogRateMovie()">
              Rate
            </button>
            <button type="button" class="movie_button" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
              Credits
            </button>
            <button type="button" class="movie_button" *ngIf="checkSpotlightEvent(movie)"
              (click)="navigateToSpolightEvent(movie)">
              Spotlight
            </button>
            <button type="button" class="movie_button" *ngIf="checkScreeningPartyEvent(movie)"
              (click)="navigateToScreeningParty()">
              Join Screening Party
            </button>
          </div>
          <div class="web-share-button" fxLayout="row wrap">
            <button (click)="shareButton('facebook')" class="movie_button">
              <i class="fa fa-facebook" aria-hidden="true"></i>
              <meta name="description" content="Free Web tutorials f">
            </button>

            <button (click)="shareButton('twitter')" class="movie_button">
              <i class="fa fa-twitter" aria-hidden="true"></i>
              <meta name="description" content="Free Web tutorials f">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="" fxLayout="row" fxLayoutAlign="space-around" *ngIf="movie">
    <div></div>

    <div class="Social-icon-section" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="30px">
      <span class="follow-label">Follow us on</span>
      <a target="_blank" href="https://www.instagram.com/creaticsorg"><i class="fa fa-instagram fa-3x"
          aria-hidden="true"></i></a>
      <a target="_blank" href="https://www.facebook.com/CreaticsEnterprises"><i class="fa fa-facebook fa-3x"
          aria-hidden="true"></i></a>
      <a target="_blank" href="https://twitter.com/Creatics2"><i class="fa fa-twitter fa-3x" aria-hidden="true"></i></a>
    </div>
  </div>

  <div fxLayout="row wrap" style="justify-content: space-evenly;">

    <div style="font-family: 'Poppins Regular' !important;
    font-size: 18px !important;">
      <p style="margin-left: 5%;">Instagram Feed:</p>
      <div class="web-instagram-section">
        <iframe src="https://embedsocial.com/facebook_album/pro_hashtag/4938ccaed260b7490f121c7fa363595dbd354bd3" width="900px" height="1200px" frameborder="0" marginheight="0" marginwidth="0"></iframe>
      </div>
    </div>
    <div style="font-family: 'Poppins Regular' !important;
    font-size: 18px !important;">
      <p>Twitter Feed:</p>
      <div class="web-instagram-section">
        <iframe style="overflow: hidden;" src="https://embedsocial.com/facebook_album/pro_hashtag/6146aadf7760bb18e0fbb5fcaca874755f462219"
          width="600px" height="1200px" frameborder="0" marginheight="0" marginwidth="0"></iframe>
      </div>
    </div>
  </div>


  <div>
    <!-- Modal -->
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <table>
              <tr>
                Cast:
                <td>
                  <div>{{ movie?.casts }}</div>
                </td>
              </tr>
              <tr>
                Director:
                <td>
                  <div>{{ movie?.directors }}</div>
                </td>
              </tr>
              <tr>
                Producer:
                <td>
                  <div>{{ movie?.producers }}</div>
                </td>
              </tr>
              <tr>
                Writer:
                <td>
                  <div>{{ movie?.screenwriters }}</div>
                </td>
              </tr>
              <tr>
                DP:
                <td>
                  <div>{{ movie?.cinematographers }}</div>
                </td>
              </tr>
              <tr>
                Editors:
                <td>
                  <div>{{ movie?.editors }}</div>
                </td>
              </tr>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="movie_button" data-bs-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="mobile-view" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxHide.gt-lg>
  <div *ngIf="showSideBar">
    <app-movie-page-side-bar class="web-sideBar"></app-movie-page-side-bar>
  </div>
  <div fxLayout="row"
    style="justify-content: space-between !important; align-items: center; height: 50px; margin: 5px; color: white; ">
    <div class="" style="font-size: 30px;" (click)="openSideBar()">☰</div>
    <div style=" font-size: 35px; font-family: 'Teko Light';
  color: white;
  text-decoration: none;">cinejoy</div>
    <div class="" style="font-size: 24px;"><app-shopping-cart></app-shopping-cart></div>
  </div>

  <div class="mob-background-img">
    <img id="mob-back-arrow" (click)="backClicked()" [src]="backArrow" alt="backArrow" />
    <img id="mob-background-img" src="{{ movie?.mobilethumbimage }}" fxHide fxShow.handset.portrait
      fxShow.tablet.portrait alt="" />
    <img id="mob-background-img" src="{{ movie?.eventImage }}" fxHide fxShow.gt-sm fxShow.handset.landscape alt="" />
  </div>
  <div class="cinequestLogo" fxLayout="row">
    <img class="logo" src="assets/images/spotlight/Laurel.png" />
  </div>
  <div class="mobile-content-div">
    <h1 class="mob-heading">{{ movie?.name }}</h1>
    <hr id="mob-hr" width="20px" />
    <p [innerHTML]="movie?.FullDescription" class="mob-paragraph"></p>

    <div class="mob-credits">
      <p>{{ movie?.casts }}</p>
    </div>


    <div fxLayout="row wrap" fxLayoutGap="30px" class="mob-rating-time">
      <div>{{ movie?.rating }}/10</div>
      <div>{{ movie?.country }}</div>
      <div>{{ movie?.runtime }} mins</div>
    </div>
    <div class="mob-button-div" fxLayoutAlign="row wrap" fxLayoutGap="10px">
      <button>{{ movie?.tags[0] }}</button>
      <button>{{ movie?.tags[1] }}</button>
      <button>{{ movie?.tags[2] }}</button>
    </div>
    <div id="mob-shortDescription">
      <p>
        Official Selection of Cinejoy featuring Cinequest Artists March 21 - March 31, 2024
      </p>

      <div fxLayout="row wrap" fxLayoutGap="10px">
        <button type="button" class="mob_movie_button" *ngIf="movie.showbuybutton"
          (click)="open(movie.eventId, movie, 'Buy')">
          Buy Tks
        </button>
        <button type="button" class="mob_movie_button" *ngIf="movie.showwatchbutton"
          [routerLink]="['/cinejoy/showcase/movie/stream/', movie.eventId, getmovieName(movie.name)]">
          Watch
        </button>
        <button *ngIf="movie.user > 0" type="button" class="mob_movie_button" (click)="openDialogRateMovie()">
          Rate
        </button>
        <button type="button" class="mob_movie_button" data-bs-toggle="modal" data-bs-target="#staticBackdrop1">
          Credits
        </button>
        <button type="button" class="mob_movie_button" *ngIf="checkScreeningPartyEvent(movie)"
          (click)="navigateToScreeningParty()">
          Join Screening Party
        </button>
        <button (click)="shareButton('facebook')" class="movie_button mob-btn">
          <i class="fa fa-facebook" aria-hidden="true"></i>
          <meta name="description" content="Free Web tutorials f">
        </button>

        <button (click)="shareButton('twitter')" class="movie_button mob-btn">
          <i class="fa fa-twitter" aria-hidden="true"></i>
          <meta name="description" content="Free Web tutorials f">
        </button>
      </div>

      <div class="mob-video-div">
        <iframe class="mob-trailer-iframe" allowfullscreen="" frameborder="0" mozallowfullscreen="" [src]="trailerUrl"
          webkitallowfullscreen="">
        </iframe>
        <iframe *ngIf="movie?.video1" class="mob-short-trailer-iframe" allowfullscreen="" frameborder="0"
          mozallowfullscreen="" [src]="splContent" webkitallowfullscreen="">
        </iframe>
        <iframe *ngIf="movie?.video2" class="mob-short-trailer-iframe" allowfullscreen="" frameborder="0"
          mozallowfullscreen="" [src]="splContent1" webkitallowfullscreen="">
        </iframe>

        <div class="mob-footer" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="70px">
          <a target="_blank" href="https://www.instagram.com/creaticsorg"><i class="fa fa-instagram fa-3x"
              aria-hidden="true"></i></a>

          <a target="_blank" href="https://www.facebook.com/CreaticsEnterprises"><i class="fa fa-facebook fa-3x"
              aria-hidden="true"></i></a>
          <a target="_blank" href="https://twitter.com/Creatics2"><i class="fa fa-twitter fa-3x"
              aria-hidden="true"></i></a>
        </div>

        <p>Instagram Feed:</p>
        <div class="mob-instagram-section">
          <iframe style="overflow: hidden;"
            src="https://embedsocial.com/facebook_album/pro_hashtag/8ce344b095b2c45a49b5cd02ab75a6269bd85d22"
            width="900px" height="80vh" frameborder="0" marginheight="0" marginwidth="0"></iframe>
        </div>
        <p>Twitter Feed:</p>
        <div class="twitter-div">
          <div class="mob-instagram-section">
            <iframe style="overflow: hidden;" src="https://embedsocial.com/facebook_album/pro_hashtag/6146aadf7760bb18e0fbb5fcaca874755f462219"
            width="600px" height="1200px" frameborder="0" marginheight="0" marginwidth="0"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <table>
            <tr>
              Cast:
              <td>
                <div>{{ movie?.casts }}</div>
              </td>
            </tr>
            <tr>
              Director:
              <td>
                <div>{{ movie?.directors }}</div>
              </td>
            </tr>
            <tr>
              Producer:
              <td>
                <div>{{ movie?.producers }}</div>
              </td>
            </tr>
            <tr>
              Writer:
              <td>
                <div>{{ movie?.screenwriters }}</div>
              </td>
            </tr>
            <tr>
              DP:
              <td>
                <div>{{ movie?.cinematographers }}</div>
              </td>
            </tr>
            <tr>
              Editors:
              <td>
                <div>{{ movie?.editors }}</div>
              </td>
            </tr>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="movie_button" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>